var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkdown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.4 27l-8 8.1c-.7.7-2 .7-2.9 0l-8-8.1c-.7-.7-.8-1.9-.1-2.6s1.9-.5 2.6.3c.8.8 4.9 4.3 4.9 4.3V13.4c0-1.7 4-1.6 4 0V29s4.4-3.9 5.1-4.6c1.2-1.2 2.9.1 2.9 1.2.1.5-.2.9-.5 1.4zM26 35.4h-5V18.6l-6.1 8.3-2.4 3.3-2.4-3.3L4 18.6v16.8H0v-23h6l7 9.8 7.1-9.8H26z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0OCIgaGVpZ2h0PSI0OCIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48cGF0aCBkPSJNNDcuNCAyN2wtOCA4LjFjLS43LjctMiAuNy0yLjkgMGwtOC04LjFjLS43LS43LS44LTEuOS0uMS0yLjZzMS45LS41IDIuNi4zYy44LjggNC45IDQuMyA0LjkgNC4zVjEzLjRjMC0xLjcgNC0xLjYgNCAwVjI5czQuNC0zLjkgNS4xLTQuNmMxLjItMS4yIDIuOS4xIDIuOSAxLjIuMS41LS4yLjktLjUgMS40ek0yNiAzNS40aC01VjE4LjZsLTYuMSA4LjMtMi40IDMuMy0yLjQtMy4zTDQgMTguNnYxNi44SDB2LTIzaDZsNyA5LjggNy4xLTkuOEgyNnoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPjwvc3ZnPgo=";
export { SvgMarkdown as ReactComponent };